module.exports = "<span *ngIf=\"!isVisible; else elseTpl\"></span>\n<ng-template #elseTpl><ng-content></ng-content></ng-template>\n"


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/permission-wrapper/permission-wrapper.component.html
// module id = ../../../../../src/app/permission-wrapper/permission-wrapper.component.html
// module chunks = main